import(/* webpackMode: "eager", webpackExports: ["NotFoundPage"] */ "/workspace/frontend/app/components/notFound/NotFound.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/frontend/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
